import { render, staticRenderFns } from "./LandlineNumber.vue?vue&type=template&id=6a23b3e7&scoped=true"
import script from "./LandlineNumber.vue?vue&type=script&lang=js"
export * from "./LandlineNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a23b3e7",
  null
  
)

export default component.exports